module.exports = __webpack_public_path__ + "img/bo.feb8b3df.svg";